import { createContext, useContext, type ReactNode } from 'react'

export type AgentPanelContextValue = {
  /** Desktop agent split can be toggled on the current shell. */
  available: boolean
  agentCollapsed: boolean
  pageCollapsed: boolean
  /** Hide the agent column (page takes full width). */
  collapseAgent: () => void
  /** Restore the agent column from agent-collapsed state. */
  showAgent: () => void
  /** Collapse the page column (agent takes full width). */
  collapsePage: () => void
}

const AgentPanelContext = createContext<AgentPanelContextValue | null>(null)

type AgentPanelProviderProps = {
  value: AgentPanelContextValue
  children: ReactNode
}

export function AgentPanelProvider({ value, children }: AgentPanelProviderProps) {
  return <AgentPanelContext.Provider value={value}>{children}</AgentPanelContext.Provider>
}

export function useAgentPanel(): AgentPanelContextValue {
  const ctx = useContext(AgentPanelContext)
  return (
    ctx ?? {
      available: false,
      agentCollapsed: true,
      pageCollapsed: false,
      collapseAgent: () => {},
      showAgent: () => {},
      collapsePage: () => {},
    }
  )
}
